import React, { useMemo, useRef } from 'react';
import { motion } from 'framer-motion';
import { plinkoDuration, plinkoTrajectory } from './plinkoMath';
import { PLINKO_BALL_COLORS } from './plinkoColors';

export const PlinkoBall = ({ round, onHit, onLand }) => {
  const path = useMemo(() => plinkoTrajectory(round.outcome.path), [round]);
  const nextHit = useRef(0), ended = useRef(false);
  return <motion.circle data-testid={`plinko-ball-${round.request_id}`} data-risk={round.params.risk} className="plinko-ball" style={{ '--plinko-current-ball': PLINKO_BALL_COLORS[round.params.risk] }} r="6.3" cx="320" cy="12"
    initial={{ cx: 320, cy: 12 }} animate={{ cx: path.xs, cy: path.ys }} transition={{ duration: plinkoDuration(round.params.rows) / (round.turbo ? 2.6 : 1), times: path.times, ease: path.times.slice(1).map((_, index) => index % 3 === 1 ? 'easeOut' : 'easeIn') }}
    onUpdate={({ cy }) => {
      while (nextHit.current < path.hits.length && cy >= path.hits[nextHit.current].y - 1) {
        onHit(path.hits[nextHit.current].key, nextHit.current, round.params.risk); nextHit.current += 1;
      }
    }} onAnimationComplete={() => { if (!ended.current) { ended.current = true; onLand(round); } }} />;
};